<template>
  <div  v-if="getPerformanceData && getPerformanceData.ranking" class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7">
      <h1 class="fs-18 fs-md-20 fw-semibold mb-0">Ranking Atendentes</h1>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25 mt-10">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>

              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Atendente
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Valor Atendimentos
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Valor vendas
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Taxas de pagamento
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Qtd. atendimentos
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Qtd. clientes atendidos
              </th>
            </tr>
          </thead>
          <tbody>




            <tr v-for="(value, key) in getPerformanceData.ranking" :key="key">

              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                {{ value.name }}
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                R$ {{ value.total_value }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                R$ {{ value.amount_sold }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                R$ -{{ value.tax }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.qtd_attendances }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.number_of_customers_served }}
              </td>

            </tr>
          
          
          
          
          </tbody>
        </table>
      </div>

      <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20">
        <div class="fs-14 text-muted mb-10 mb-sm-0">
          Página {{ currentPage }} de {{ getPerformanceRankingPagination.last_page || 1 }} —
          Total de {{ getPerformanceRankingPagination.total || getPerformanceData.ranking.length }} atendentes
        </div>
        <nav aria-label="Paginação do ranking de atendentes">
          <ul class="pagination mb-0">
            <li class="page-item" :class="{ disabled: currentPage <= 1 }">
              <button type="button" class="page-link" @click="goToPage(currentPage - 1)" :disabled="currentPage <= 1">
                Anterior
              </button>
            </li>
            <li class="page-item" :class="{ disabled: currentPage >= getPerformanceRankingPagination.last_page }">
              <button type="button" class="page-link" @click="goToPage(currentPage + 1)" :disabled="currentPage >= getPerformanceRankingPagination.last_page">
                Próxima
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default defineComponent({
  name: "RankingPerformanceAttendants",
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters([
      'getPerformanceData',
      'getPerformanceRankingPagination',
      'getPerformanceQuery'
    ]),
    
  },
  methods: {
    ...mapActions([
      "fetchPerformanceData"
    ]),
    async loadPage(page) {
      if (!page || page < 1) {
        page = 1;
      }
      this.currentPage = page;
      await this.fetchPerformanceData({
        month: this.getPerformanceQuery?.month,
        year: this.getPerformanceQuery?.year,
        user_id: this.getPerformanceQuery?.user_id,
        page,
      });
    },
    goToPage(page) {
      if (page < 1 || (this.getPerformanceRankingPagination.last_page && page > this.getPerformanceRankingPagination.last_page)) {
        return;
      }
      this.loadPage(page);
    },
    formtattedDate(date, hour) {
      return moment(date).format('DD/MM/YYYY') + ' ' + hour;
    }
  },
  watch: {
    getPerformanceRankingPagination: {
      immediate: true,
      handler(newVal) {
        this.currentPage = newVal && newVal.current_page ? newVal.current_page : 1;
      }
    }
  },
});
</script>